










import { Component, Prop, Model, Emit, Vue } from "vue-property-decorator";

@Component
export default class InputImageBox extends Vue {
  @Model("change", { type: String }) selected!: string;
  @Prop({ required: true }) private answerId!: string;
  @Prop() private image!: string;

  get isActive() {
    return this.answerId == this.selected;
  }

  @Emit("change")
  private onClick(): string {
    return this.answerId;
  }
}
